import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { MyDatePickerModule } from 'mydatepicker/dist/my-date-picker.module';
import { AUTH_PROVIDERS } from 'angular2-jwt';
import { TextMaskModule } from 'angular2-text-mask';
import { TooltipModule } from 'ng2-bootstrap/tooltip';

import { CVFormService } from './coverage-form.service';
import { CoverageFormComponent } from './coverage-form.component';
import { NavigationComponent } from './navigation/navigation.component';
import { NavService } from './navigation/navigation.service';
import { NavGuard } from './navigation/navigation-guard.service';
import { MonthlyRateComponent } from './monthly-rate/monthly-rate.component';
import { FormDispatcherComponent } from './form-dispatcher/form-dispatcher.component';
import { FormApplicationStatusComponent } from './form-application-status/form-application-status.component';
import { FormCustomerInformationComponent } from './form-customer-information/form-customer-information.component';
import { FormDriverInformationComponent } from './form-driver-information/form-driver-information.component';
import { FormMotorCarrierInformationComponent } from './form-motor-carrier-information/form-motor-carrier-information.component';
import { FormReviewCoverageComponent } from './form-review-coverage/form-review-coverage.component';
import { FormVehiclesInformationComponent } from './form-vehicles-information/form-vehicles-information.component';
import { FormApplicationSummaryComponent } from './form-application-summary/form-application-summary.component';
import { CoverageFormResolverService } from './coverage-form-resolver.service';

import { DisplayQuoteComponent } from './../display-quote/display-quote.component';

import { FORM_ROUTES } from './coverage-form.routes';

import {
  DataHelperService,
  BackendService,
  InsuranceService,
  formReducer,
  PaxFormControlComponent
} from './../shared/index';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot(FORM_ROUTES, { useHash: true }),
    StoreModule.provideStore({ cvform: formReducer }),
    StoreDevtoolsModule.instrumentOnlyWithExtension(),
    ReactiveFormsModule,
    MyDatePickerModule,
    TextMaskModule,
    TooltipModule.forRoot()
  ],
  declarations: [
    CoverageFormComponent,
    NavigationComponent,
    MonthlyRateComponent,
    FormDispatcherComponent,
    FormApplicationStatusComponent,
    FormCustomerInformationComponent,
    FormDriverInformationComponent,
    FormMotorCarrierInformationComponent,
    FormReviewCoverageComponent,
    FormVehiclesInformationComponent,
    FormApplicationSummaryComponent,
    DisplayQuoteComponent,
    PaxFormControlComponent
  ],
  providers: [
    DataHelperService,
    BackendService,
    InsuranceService,
    NavService,
    NavGuard,
    CVFormService,
    CoverageFormResolverService,
    AUTH_PROVIDERS
  ],
  bootstrap: [CoverageFormComponent]
})
export class CoverageFormModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/coverage-form.module.ts